import {NavLink} from 'react-router-dom';
import {useSubscriptions} from '../../../subscriptions';
import {Subscription} from '../../../subscriptions/types';
import {StatusBadge} from '../../../subscriptions/profile/StatusBadge';
import {
    Group,
    Paper,
    Stack,
    Table,
    Text,
    Title,
    Button,
} from '@mantine/core';

export const RecentSubscriptionsWidget = () => {

    const {items, loading} = useSubscriptions();

    return (
        <Paper shadow="sm" p="lg" radius="md" withBorder>
            <Stack gap="md">
                <Group justify="space-between">
                    <Title order={5}>Recent Subscriptions</Title>
                    <Button variant="subtle" size="xs" component={NavLink} to="/subscriptions">
                        View All
                    </Button>
                </Group>

                {loading ? (
                    <Text size="sm" c="dimmed">Loading...</Text>
                ) : items.length === 0 ? (
                    <Text size="sm" c="dimmed">No subscriptions yet</Text>
                ) : (
                    <Table verticalSpacing="xs" highlightOnHover>
                        <Table.Thead>
                            <Table.Tr>
                                <Table.Th>ID</Table.Th>
                                <Table.Th>Description</Table.Th>
                                <Table.Th>Status</Table.Th>
                            </Table.Tr>
                        </Table.Thead>
                        <Table.Tbody>
                            {items.map((item: Subscription) => (
                                <Table.Tr key={item.id}>
                                    <Table.Td>
                                        <Text size="sm" truncate maw={160}>{item.id}</Text>
                                    </Table.Td>
                                    <Table.Td>
                                        <Text size="sm">{item.description || '-'}</Text>
                                    </Table.Td>
                                    <Table.Td>
                                        {item.status && <StatusBadge status={item.status}/>}
                                    </Table.Td>
                                </Table.Tr>
                            ))}
                        </Table.Tbody>
                    </Table>
                )}
            </Stack>
        </Paper>
    );
};
